import ServiceBase from "@app/shared/serviceBase";
import { FailedIngestionProject, RetryIngestionResult } from "@app/operations/provider-hub-ingestion-retry/interfaces";

export class IngestionRetryService extends ServiceBase {
  public async getFailedIngestions(): Promise<FailedIngestionProject[]> {
    return await this.makeGet<FailedIngestionProject[]>("servicingAccessPoints/failed-ingestions");
  }

  public async retryIngestions(items: FailedIngestionProject[]): Promise<RetryIngestionResult> {
    return await this.makePost<RetryIngestionResult>("servicingAccessPoints/retry-ingestion", items);
  }
}
